module.exports = __webpack_public_path__ + "static/media/iphone_11_black.9f0b2ba2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_11_black.png
// module id = 2115
// module chunks = 0